module.exports = __webpack_public_path__ + "static/media/address_separator.8599b7cd.svg";